import { Link } from "react-router-dom";
import { FiBookOpen, FiMessageSquare, FiAward, FiTrendingUp } from "react-icons/fi";

const features = [
  { icon: <FiBookOpen size={32} />, title: "Expert Courses", desc: "Learn from top instructors with structured courses" },
  { icon: <FiMessageSquare size={32} />, title: "AI Tutor", desc: "Ask doubts anytime, get instant AI explanations" },
  { icon: <FiAward size={32} />, title: "Quizzes & Certificates", desc: "Test your knowledge and earn certificates" },
  { icon: <FiTrendingUp size={32} />, title: "Personalized Path", desc: "AI creates a custom learning roadmap for you" },
];

const Home = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Learn Smarter with BrainPath AI</h1>
          <p className="text-xl mb-8 text-indigo-100">
            AI-powered learning platform that adapts to you. Study notes, quizzes, flashcards — all generated by AI.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/register" className="px-8 py-3 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-gray-100 transition">
              Get Started Free
            </Link>
            <Link to="/courses" className="px-8 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-indigo-600 transition">
              Browse Courses
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Why BrainPath AI?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((f, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-md text-center hover:shadow-lg transition">
                <div className="text-indigo-600 mb-4 flex justify-center">{f.icon}</div>
                <h3 className="font-semibold text-lg mb-2">{f.title}</h3>
                <p className="text-gray-500 text-sm">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-indigo-600 text-white text-center">
        <h2 className="text-3xl font-bold mb-4">Ready to start learning?</h2>
        <p className="text-indigo-100 mb-8">Join thousands of students already using BrainPath AI</p>
        <Link to="/register" className="px-8 py-3 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-gray-100">
          Sign Up for Free
        </Link>
      </section>
    </div>
  );
};

export default Home;
